import TiptapOl from '@tiptap/extension-ordered-list';
import classNames from 'classnames';

import {type ExtendedRegExpMatchArray, wrappingInputRule} from '@tiptap/core';

import appStyles from '../app-post-style.module.css';

export const inputRegex = /^(\d+)\.\s$/;
const TextStyleName = 'textStyle';

export const TimeWebkitOrderedListExtension = TiptapOl.extend({
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-7': () => {
                if (this.editor.isActive('table')) {
                    return false;
                }
                return this.editor.commands.toggleOrderedList();
            },
        };
    },
    addInputRules() {
        let inputRule = wrappingInputRule({
            find: inputRegex,
            type: this.type,
            getAttributes: getOrderedListAttrs,
            joinPredicate: (match, node) => node.childCount + node.attrs.start === Number(match[1]),
        });

        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = wrappingInputRule({
                find: inputRegex,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: (match) => ({...getOrderedListAttrs(match), ...this.editor.getAttributes(TextStyleName)}),
                joinPredicate: (match, node) => node.childCount + node.attrs.start === Number(match[1]),
                editor: this.editor,
            });
        }
        return [
            {
                ...inputRule,
                handler: (props) => {
                    if (this.editor.isActive('table')) {
                        return;
                    }
                    return inputRule.handler(props);
                },
            },
        ];
    },
}).configure({
    HTMLAttributes: {
        class: classNames(appStyles.list, appStyles.orderedList),
    },
});

export function getOrderedListAttrs(match: ExtendedRegExpMatchArray) {
    let start = Number(match[1]);
    if (start >= 10) {
        start = 1;
    }

    return {start};
}
